(function($) {
	formHelper.addRule({
		form: '.form-go-to-site-tool',
		status: {
			SUCCESS: function() {
				//this.redirect(this.data.redirectTo);
				window.open(this.data.redirectTo, '_blank');
			}
		}
	});
})(jQuery);
